import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-84f9eae2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "notice-design-title-row" }
const _hoisted_3 = { class: "notice-design-labels" }
const _hoisted_4 = {
  key: 0,
  class: "notice-design-badge"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notice-design-privacy" }, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createElementVNode("span", {
      class: "notice-design-lock",
      "aria-hidden": "true"
    }, [
      /*#__PURE__*/_createElementVNode("span")
    ]),
    /*#__PURE__*/_createTextVNode("仅管理员可见")
  ]),
  /*#__PURE__*/_createElementVNode("p", null, "仅本机构管理员可见，员工及客户不可见。请放心阅读。")
], -1))
const _hoisted_6 = ["src", "alt"]
const _hoisted_7 = {
  key: 0,
  class: "notice-design-tip"
}
const _hoisted_8 = {
  key: 1,
  class: "notice-design-error",
  role: "alert"
}
const _hoisted_9 = { class: "notice-design-actions" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "notice-design-footer" }

import {computed} from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'AdminNoticeCard',
  props: {
    notice: null,
    expanded: { type: Boolean, default: false },
    busy: { type: Boolean, default: false },
    error: { default: '' }
  },
  emits: ['later','view','confirm'],
  setup(__props: any) {

const props = __props as { notice:any, expanded:boolean, busy:boolean, error:string };



const allowedLabels=["重要事项","经营通知","合作政策","活动通知","结算提醒","服务更新"]
const labels=computed(()=>{let list=props.notice?.tags;try{if(!Array.isArray(list))list=props.notice?.tagsJson==null?(props.notice?.important?['重要事项']:[]):JSON.parse(props.notice.tagsJson)}catch{list=props.notice?.important?['重要事项']:[]}return Array.from(new Set((Array.isArray(list)?list:[]).filter((x:any)=>allowedLabels.includes(x))))})
function noticeImages(n:any):string[]{let value=n?.images??n?.imageData;if(typeof value==='string'){try{value=value.startsWith('[')?JSON.parse(value):[value]}catch{return []}}return (Array.isArray(value)?value:[]).filter((x:any)=>typeof x==='string' && /^data:image\/(png|jpeg|webp);base64,/.test(x)).slice(0,9)}
const images=computed(()=>noticeImages(props.notice))
const theme=computed(()=>['ocean','paper','navy','gold','jade'].includes(props.notice?.styleKey)?props.notice.styleKey:'ocean')

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["admin-notice-design", 'notice-theme-'+_unref(theme)]),
    "aria-label": __props.notice.title
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(__props.notice.title), 1),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(labels), (label) => {
          return (_openBlock(), _createElementBlock("span", {
            key: label,
            class: "notice-design-badge"
          }, _toDisplayString(label), 1))
        }), 128)),
        (!_unref(labels).length)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, "管理员专属"))
          : _createCommentVNode("", true)
      ])
    ]),
    _hoisted_5,
    _createElementVNode("div", {
      class: _normalizeClass(["notice-design-body", {expanded: __props.expanded}])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(images), (image, index) => {
        return (_openBlock(), _createElementBlock("img", {
          key: index,
          src: image,
          alt: '通知图片 '+(index+1)
        }, null, 8, _hoisted_6))
      }), 128)),
      _createElementVNode("p", null, _toDisplayString(__props.notice.body), 1)
    ], 2),
    (!__props.expanded && __props.notice.important)
      ? (_openBlock(), _createElementBlock("p", _hoisted_7, "请先查看完整通知，再确认收到。"))
      : _createCommentVNode("", true),
    (__props.error)
      ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(__props.error), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        type: "button",
        disabled: __props.busy,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('later')))
      }, "稍后", 8, _hoisted_10),
      (!__props.expanded)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            disabled: __props.busy,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('view')))
          }, "查看完整通知", 8, _hoisted_11))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "notice-design-primary",
        disabled: __props.busy || __props.notice.confirmed || __props.notice.important && !__props.expanded,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('confirm')))
      }, _toDisplayString(__props.notice.confirmed?'已确认收到':'确认收到'), 9, _hoisted_12)
    ]),
    _createElementVNode("p", _hoisted_13, _toDisplayString(__props.notice.confirmed?'已在各端同步确认状态':'确认收到后，管理端、网页客户端和小程序均不再自动弹出本条通知。'), 1)
  ], 10, _hoisted_1))
}
}

})